import axios from 'axios';
import {
  MDBAccordion,
  MDBAccordionItem,
  MDBBtn,
  MDBBtnGroup,
  MDBCardFooter,
  MDBCardHeader,
  MDBCarousel,
  MDBCarouselItem,
  MDBCheckbox,
  MDBCol,
  MDBContainer,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBInput,
  MDBLightbox,
  MDBLightboxItem,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBRow,
  MDBScrollbar,
  MDBTable,
  MDBTextArea,
  MDBTypography
} from 'mdb-react-ui-kit';
// import './../custom.scss'
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { UserProfileContext } from '../context/UserProfileProvider';
import { generateQtnAnsPDF } from '../utils/Common';
const RocketDemoBuilderForm = () => {
  const { tokenLoaded } = useContext(UserProfileContext);
  const [viewMode, setViewMode] = useState(false); // New state for view mode

 const initialFormStructure = [
  {
    id: '', 
    title: '', 
    clientView: false, 
    user: {
      webSiteUrl: '',
      companyName: '',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      role: ''
    },
    sections: [
      {
        sectionTitle: '', 
        bgColor: 'white', 
        blockquote: '', 
        textColor: 'white', 
        imageUrl: '', 
        imageUrls: [''], // Initialized as an array with an empty string for the first URL
        imageType: 'image', // Default type to 'image'
        description:'',
        categories: [
          {
            categoryTitle: '', 
            description: '', 
            checkBox: false, 
            numberOfSubCategories: 1, 
            bgColor: 'white', 
            textColor: 'white', 
            blockquote: '', 
            imageUrl: '', 
            questions: [
              {
                question: '', 
                answer: '', 
                booleanAnswer: false, 
                bgColor: 'white', 
                textColor: 'white', 
                blockquote: '', 
                imageUrl: '' 
              }
            ],
            subCategories: [
              {
                categoryTitle: 'Subcategory 1', 
                description: '', 
                checkBox: false, 
                bgColor: 'white', 
                textColor: 'white', 
                blockquote: '', 
                imageUrl: '', 
                imageUrls: [], // Initialized as an empty array
                type: 'image', 
                questions: [
                  {
                    question: '', 
                    answer: '', 
                    booleanAnswer: false, 
                    bgColor: 'white', 
                    textColor: 'white', 
                    blockquote: '', 
                    imageUrl: '' 
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];


const [imageUrls, setImagesUrsl] = useState();
const [isOpen, setIsOpen] = useState(false);
  const handleCategoryTitleChange = (formIndex, sectionIndex, categoryIndex, value) => {
    const updatedForms = [...formStructure]; // Clone the form structure array
    const updatedCategories = updatedForms[formIndex].sections[sectionIndex].categories; // Get categories in the section
    
    // Update the category title
    updatedCategories[categoryIndex].categoryTitle = value;
  
    setFormStructure(updatedForms); // Set the updated form structure
  };
  
 
  const toggleViewMode = () => {
    setViewMode(!viewMode); // Toggle between view and edit mode
  };
  const clearQuestions = (formId) => {
    // Find the form by formId
    const formToClear = formStructure.find((f) => f.id === formId);
  
    // If no form is found with the given ID, log an error and return
    if (!formToClear) {
      console.error(`Form with ID ${formId} not found`);
      return;
    }
  
    // Create a new form structure with all values reset
    const clearedForm = {
      ...formToClear,
     
      user: {
        webSiteUrl: '',
        companyName: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        role: ''
      },
      sections: formToClear.sections.map((section) => ({
        ...section,
       
        
        categories: section.categories.map((category) => ({
          ...category,
         
          description: '', // Reset category description
          imageUrls: [''],
        
          imageUrl: '', // Reset category image URL
          questions: category.questions.map((question) => ({
            ...question,
           
            answer: '', // Reset answer
            booleanAnswer: false, // Reset checkbox answer
            bgColor: 'white', // Reset question background color
            textColor: 'white', // Reset question text color
           
            imageUrl: '' // Reset question image URL
          })),
          subCategories: category.subCategories.map((subCategory) => ({
            ...subCategory,           
            description: '', // Reset subcategory description           
            imageUrl: '', // Reset subcategory image URL
            questions: subCategory.questions.map((question) => ({
              ...question,            
              booleanAnswer: false, 
              blockquote: '', // Reset subcategory question blockquote
              imageUrl: '' // Reset subcategory question image URL
            }))
          }))
        }))
      }))
    };
  
    // Update the form structure with the cleared form
    setFormStructure((prevState) =>
      prevState.map((form) => (form.id === formId ? clearedForm : form))
    );
  };
  
  
  

  const [formStructure, setFormStructure] = useState(initialFormStructure);
  const [newCategoryTitles, setNewCategoryTitles] = useState({});
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;

  const handleInputChange = (formId, field, value) => {
    setFormStructure((prevState) => {
      const updatedForms = [...prevState];
  
      // Find the form using its ID
      const form = updatedForms.find(f => f.id === formId);
      if (!form) {
        console.error(`Form with ID ${formId} not found`);
        return prevState; // Return the previous state if the form is not found
      }
  
      // Ensure that user object exists
      form.user = form.user || {};
  
      // Update the specific field in the user object
      form.user[field] = value;
  
      return updatedForms; // Return the updated forms array
    });
  };
  
 
  
  
  
  const clearUserField = (field) => {
    handleInputChange(field, '');
  };


  const clearQuestionAnswer = (formIndex, sectionIndex, categoryIndex, questionIndex) => {
    handleAnswerInputChange(formIndex, sectionIndex, categoryIndex, questionIndex, '');
  };
  
 

 // Add a new category to the given section
const addCategory = (formIndex, sectionIndex) => {
  const newCategory = {
    categoryTitle: "New Category",
    description: "",
    checkBox: false,
    questions: [{ question: "", answer: "" }]
  };

  const updatedForms = [...formStructure]; // Copy formStructure array
  const updatedSections = updatedForms[formIndex].sections; // Get the sections of the specific form

  updatedSections[sectionIndex].categories.push(newCategory); // Add the new category to the section

  setFormStructure(updatedForms); // Update the form structure
};

  // Remove a category
const removeCategory = (formIndex, sectionIndex, categoryIndex) => {
  const updatedForms = [...formStructure]; // Copy the entire form structure

  // Make sure the form, section, and category exist
  if (
    updatedForms[formIndex] &&
    updatedForms[formIndex].sections[sectionIndex] &&
    updatedForms[formIndex].sections[sectionIndex].categories
  ) {
    // Filter out the category to remove it
    updatedForms[formIndex].sections[sectionIndex].categories = 
      updatedForms[formIndex].sections[sectionIndex].categories.filter(
        (_, index) => index !== categoryIndex
      );
    
    // Update the form structure with the modified sections
    setFormStructure(updatedForms);
    
    // Optionally, update newCategoryTitles if you manage the titles separately
    const newTitles = { ...newCategoryTitles };
    delete newTitles[`${sectionIndex}-${categoryIndex}`];
    setNewCategoryTitles(newTitles);
  }
};


const addQuestion = (formId, sectionIndex, categoryIndex) => {
  const newQuestion = { question: "", answer: "", booleanAnswer: false, bgColor: "white", textColor: "black", blockquote: "", imageUrl: "" };

  const updatedForms = cloneDeep(formStructure); // Deep clone the form structure

  // Find the form by its id
  const form = updatedForms.find(f => f.id === formId);
  if (!form) {
    console.error(`Form with ID ${formId} not found`);
    return;
  }

  // Ensure the sections and categories exist
  const section = form.sections[sectionIndex];
  if (!section) {
    console.error(`Section at index ${sectionIndex} not found`);
    return;
  }

  const category = section.categories[categoryIndex];
  if (!category) {
    console.error(`Category at index ${categoryIndex} not found`);
    return;
  }

  // Add the new question to the category's questions array
  if (Array.isArray(category.questions)) {
    category.questions.push(newQuestion);
  } else {
    category.questions = [newQuestion];
  }

  // Update the form structure with the new question added
  setFormStructure(updatedForms);
};



 
useEffect(() => {
  const fetchSalesQuestions = async () => {
    try {
      const response = await axios.get(`${baseUrl}/salesquestions`);
      const formData = response.data;

      // Ensure imageUrls is initialized
      const updatedFormStructure = formData.map(form => ({
        ...form,
        sections: form.sections.map(section => ({
          ...section,
          imageUrls: section.imageUrls
        })),
      }));

      console.log("Updated Form Structure with Image URLs:", updatedFormStructure);

      setFormStructure(updatedFormStructure);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchSalesQuestions();
}, [baseUrl]);



  const prepareFormDataForSubmission = (formId) => {
    const formToSubmit = { ...formStructure.find(f => f.id === formId) };
    if (!formToSubmit) {
      console.error("Form not found with id:", formId);
      return null;
    }
  
    // Function to handle the checkbox update based on subcategories
    const updateCategoryCheckBox = (categories) => {
      return categories.map((category) => {
        const updatedCategory = { ...category };
  
        // If the category has subcategories, set checkBox to true
        if (category.subCategories && category.subCategories.length > 0) {
          updatedCategory.checkBox = true;
        }
  
        // Recursively update subcategories if needed
        if (updatedCategory.subCategories && updatedCategory.subCategories.length > 0) {
          updatedCategory.subCategories = updateCategoryCheckBox(updatedCategory.subCategories);
        }
  
        return updatedCategory;
      });
    };
  
    // Apply the checkBox update to all categories in each section
    formToSubmit.sections = formToSubmit.sections.map((section) => {
      section.categories = updateCategoryCheckBox(section.categories);
      return section;
    });
  
    return formToSubmit;
  };
  const showAlert = () => {
    setIsOpen(true);
    setTimeout(() => {
      setIsOpen(false);
    }, 3000); // Auto-hide after 3 seconds
  };
  
    
  const createSalesQuestions = async (formId) => {
    try {
      const formData = prepareFormDataForSubmission(formId);
      if (!formData) return; // If form is not found, return early
  
      const url = tokenLoaded ? `${baseUrl}/salesquestions` : `${baseUrl}/salesquestions/nlgd`;
      const response = await axios.post(url, formData);
      
      // Ensure state is updated based on whether the form already exists
      setFormStructure((prevState) => {
        const existingFormIndex = prevState.findIndex((form) => form.id === formId);
  
        if (existingFormIndex !== -1) {
          // Form exists, replace the existing form with the new one
          const updatedForms = [...prevState];
          updatedForms[existingFormIndex] = response.data;
          return updatedForms;
        } else {
          // Form doesn't exist, add the new form
          return [...prevState, response.data];
        }
      });
  
      showAlert();
    } catch (error) {
      console.error("Error creating or updating sales questions:", error);
    }
  };
  
  
  const updateSalesQuestions = async (formId) => {
    try {
      const formData = prepareFormDataForSubmission(formId);
      if (!formData) return; // If form is not found, return early
  
      const response = await axios.put(`${baseUrl}/salesquestions/${formId}`, formData);
      
      // Ensure state is updated by replacing the updated form
      setFormStructure((prevState) => 
        prevState.map((form) => (form.id === formId ? response.data : form))
      );
  
      showAlert();
    } catch (error) {
      console.error("Error updating sales questions:", error);
    }
  };
  
  


  const deleteSalesQuestions = async (formId) => {
    try {
      const form = formStructure.find(f => f.id === formId);
      if (!form) {
        console.error("Form not found with id:", formId);
        return;
      }
  
      await axios.delete(`${baseUrl}/salesquestions/${formId}`);
      
      // Update state by filtering out the deleted form
      setFormStructure((prevState) => 
        prevState.filter((form) => form.id !== formId)
      );
  
      showAlert();
    } catch (error) {
      console.error("Error deleting sales questions:", error);
    }
  };
  
  

 

  const renderSectionTitle = (tokenLoaded, viewMode, formIndex, sectionIndex, sectionTitle,blockquote, textColor, handleSectionTitleChange) => {
    if (tokenLoaded && !viewMode) {
      return (
        <MDBInput
          className='mb-0'
          label={`Section Title ${formIndex + 1}`}
          value={sectionTitle || ''}
          onChange={(e) => handleSectionTitleChange(formIndex, sectionIndex, e.target.value)} // Pass both formIndex and sectionIndex
        />
      );
    } else {
      return   <figure className='text-end mb-0 text-center'>
      <MDBTypography blockquote>
      <h3>{sectionTitle}</h3>
      </MDBTypography>
      {blockquote &&     <figcaption className='blockquote-footer mb-0'>
       <cite title='Source Title' className='text-uppercase'>{blockquote || 'No blockquote available'}</cite>
      </figcaption>}
    </figure>;

      
    }
  };
  
  const handleSectionTitleChange = (formIndex, sectionIndex, value) => {
    const updatedForms = [...formStructure]; // Clone formStructure
    updatedForms[formIndex].sections[sectionIndex].sectionTitle = value; // Update the section title for the correct form and section
    setFormStructure(updatedForms); // Update the state
  };
  
  const renderFormTitle = (
    viewMode,
    formIndex,
    formTitle,
    handleFormTitleChange,
    handleFormClientViewChange,
    clientView
  ) => {
    if (tokenLoaded && !viewMode) {
      return (
        <MDBRow>
          <MDBCol>
            <MDBInput
              className='mb-2'
              label={`Form title ${formIndex + 1}`}
              value={formTitle || ''}
              onChange={(e) => handleFormTitleChange(formIndex, e.target.value)}
            />
          </MDBCol>
          <MDBCol>
            <MDBCheckbox
              className='text-start'
              id='clientView_checkBox'
              label='Allow For Client to View'
              checked={clientView || false}  // Default to false if undefined
              onChange={() => handleFormClientViewChange(formIndex)}  // No need to pass the current value
            />
          </MDBCol>
        </MDBRow>
      );
    } else {
      return <h3>{formTitle}</h3>;
    }
  };
  
  
  
  const handleFormTitleChange = (formIndex, value) => {
    const updatedFormStructure = [...formStructure];
    updatedFormStructure[formIndex].title = value;
    setFormStructure(updatedFormStructure);
  };
  const handleFormClientViewChange = (formIndex) => {
    const updatedFormStructure = [...formStructure];
  
    if (updatedFormStructure[formIndex]) {
      // Toggle clientView value
      updatedFormStructure[formIndex].clientView = !updatedFormStructure[formIndex].clientView;
    } else {
      updatedFormStructure[formIndex] = { ...updatedFormStructure[formIndex], clientView: true };
    }
  
    setFormStructure(updatedFormStructure);
  };
 
  const handleCategoryDescriptionChange = (formId, sectionIndex, categoryIndex, value) => {
    const updatedForms = cloneDeep(formStructure); // Deep clone to avoid direct mutation
  
    // Find the form by form.id
    const form = updatedForms.find(f => f.id === formId);
  
    if (!form) {
      console.error(`Form with ID ${formId} not found`);
      return;
    }
  
    // Ensure sections and categories exist
    const section = form.sections[sectionIndex];
    if (!section) {
      console.error('Section is undefined or out of bounds');
      return;
    }
  
    const category = section.categories[categoryIndex];
    if (!category) {
      console.error('Category is undefined or out of bounds');
      return;
    }
  
    // Update the category description
    category.description = value;
  
    // Set the updated form structure
    setFormStructure(updatedForms);
  };
  

const handleSubCategoryDescriptionChange = (formId, sectionIndex, categoryIndex, subCategoryIndex, value) => {
  const updatedForms = cloneDeep(formStructure);  // Deep clone form structure

  // Find the form by its id
  const form = updatedForms.find(f => f.id === formId);
  if (!form) {
    console.error("Form not found");
    return;
  }

  const category = form.sections[sectionIndex].categories[categoryIndex];
  if (!category.subCategories || !Array.isArray(category.subCategories) || subCategoryIndex >= category.subCategories.length) {
    console.error('Subcategory index is out of bounds or undefined.');
    return;
  }

  category.subCategories[subCategoryIndex].description = value;
  setFormStructure(updatedForms);  // Set updated form structure
};




const handleAddImageUrl = (formId, sectionIndex) => {
  setFormStructure(prevState => {
    const updatedForms = cloneDeep(prevState);
    
    // Find the form by its id
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error("Form not found");
      return prevState;
    }

    const section = form.sections[sectionIndex];
    if (!section) {
      console.error("Section not found");
      return prevState;
    }

    // Initialize imageUrls as an empty array if it's not defined
    if (!Array.isArray(section.imageUrls)) {
      section.imageUrls = [];
    }

    section.imageUrls.push(''); // Add a new empty URL field

    return updatedForms;
  });
};


const handleRemoveImageUrl = (formId, sectionIndex, urlIndex) => {
  setFormStructure(prevState => {
    const updatedForms = cloneDeep(prevState);

    // Find the form by its id
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error("Form not found");
      return prevState;
    }

    const section = form.sections[sectionIndex];
    if (!section) {
      console.error("Section not found");
      return prevState;
    }

    if (Array.isArray(section.imageUrls)) {
      section.imageUrls.splice(urlIndex, 1); // Remove the URL at the specified index
    }

    return updatedForms;
  });
};

const handleImageUrlChange = (formId, sectionIndex, urlIndex, value) => {
  setFormStructure(prevState => {
    const updatedForms = cloneDeep(prevState);  // Deep clone the form structure

    // Find the form by its id
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error("Form not found");
      return prevState; // Return previous state if the form is not found
    }

    // Find the section by its index
    const section = form.sections[sectionIndex];
    if (!section) {
      console.error("Section not found");
      return prevState; // Return previous state if the section is not found
    }

    // Update imageUrls for 'carousel' or imageUrl for 'image'/'video'
    if (section.imageType === 'carousel') {
      if (Array.isArray(section.imageUrls)) {
        section.imageUrls[urlIndex] = value; // Update the specific URL in imageUrls array
        console.log(`Updated imageUrls:`, section.imageUrls);  // Log updated imageUrls
      }
    } else {
      section.imageUrl = value; // Update the imageUrl field for 'image' or 'video' type
    }

    return updatedForms; // Return the updated form structure
  });

  
};


const handleImageTypeChange = (formId, sectionIndex, value) => {
  setFormStructure(prevState => {
    const updatedForms = cloneDeep(prevState);

    // Find the form by its id
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error("Form not found");
      return prevState; 
    }

    // Find the section by its index
    const section = form.sections[sectionIndex];
    if (!section) {
      console.error("Section not found");
      return prevState;
    }

    // Store the current imageUrls if switching away from 'carousel'
    if (section.imageType === 'carousel' && value !== 'carousel') {
      section.previousImageUrls = section.imageUrls; // Store the current imageUrls
      section.imageUrls = []; // Clear imageUrls when switching to 'image' or 'video'
    }

    // Restore imageUrls if switching back to 'carousel'
    if (value === 'carousel') {
      section.imageUrls = section.previousImageUrls || ['']; // Restore the previous imageUrls or initialize with an empty string
    }

    // Set the imageType
    section.imageType = value;

    return updatedForms; // Return the updated form structure
  });
};



const handleSectionColorChange = (formId, sectionIndex, field, value) => {
  setFormStructure(prevState => {
    const updatedForms = cloneDeep(prevState);  // Deep clone the form structure

    // Find the form by its id
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error("Form not found");
      return prevState; // Return previous state if the form is not found
    }

    // Find the section by its index
    const section = form.sections[sectionIndex];
    if (!section) {
      console.error("Section not found");
      return prevState; // Return previous state if the section is not found
    }

    // Update the field in the section
    section[field] = value;

    return updatedForms; // Return the updated form structure
  });
};


const handleCategoryChange = (formIndex, sectionIndex, categoryIndex, field, value) => {
  const updatedForms = cloneDeep(formStructure);
  const category = updatedForms[formIndex].sections[sectionIndex].categories[categoryIndex];
  category[field] = value;
  setFormStructure(updatedForms);
};



  
  const handleIsCheckBoxChange = (formIndex, sectionIndex, categoryIndex, checked) => {
    const updatedForms = [...formStructure];
    updatedForms[formIndex].sections[sectionIndex].categories[categoryIndex].checkBox = checked;
  
    setFormStructure(updatedForms);  // This ensures the change is reflected in the state
  };
  
  const handleSubCategoryIsCheckBoxChange = (formIndex, sectionIndex, categoryIndex, subCategoryIndex, checked) => {
    const updatedForms = [...formStructure];
    updatedForms[formIndex].sections[sectionIndex].categories[categoryIndex].subCategories[subCategoryIndex].checkBox = checked;
  
    setFormStructure(updatedForms);  // This ensures the change is reflected in the state
  };
  

  const handleSubCategoryChange = (formIndex, sectionIndex, categoryIndex, subCategoryIndex, field, value) => {
    const updatedForms = [...formStructure]; // Clone the form structure
  
    // Get the specific subcategory and update either 'categoryTitle' or 'blockquote'
    updatedForms[formIndex].sections[sectionIndex].categories[categoryIndex].subCategories[subCategoryIndex][field] = value;
  
    setFormStructure(updatedForms); // Update the state
  };
  

  
  

  const addSubCategoryQuestion = (formIndex, sectionIndex, categoryIndex, subCategoryIndex) => {
    const newQuestion = { question: "", answer: "" };
  
    const updatedForms = [...formStructure]; // Clone the form structure
    updatedForms[formIndex].sections[sectionIndex].categories[categoryIndex].subCategories[subCategoryIndex].questions.push(newQuestion);
    
    setFormStructure(updatedForms); // Update the state
  };
 
  const handleNumberOfSubCategoriesChange = (formIndex, sectionIndex, categoryIndex, value) => {
    const updatedForms = [...formStructure]; // Clone the form structure
    const category = updatedForms[formIndex].sections[sectionIndex].categories[categoryIndex];
  
    const numberOfSubCategories = parseInt(value, 10) || 1; // Convert value to an integer (default to 1)
    category.numberOfSubCategories = numberOfSubCategories;
  
    // If there are subcategories, clear the parent category's questions array
    if (numberOfSubCategories > 1) {
      category.questions = [];
    }
  
    // Ensure that subCategories array has the correct number of subcategories
    if (!category.subCategories) {
      category.subCategories = [];
    }
  
    // Adjust the number of subcategories to match the input number
    if (category.subCategories.length > numberOfSubCategories) {
      category.subCategories = category.subCategories.slice(0, numberOfSubCategories); // Trim excess subcategories
    } else {
      while (category.subCategories.length < numberOfSubCategories) {
        category.subCategories.push({
          categoryTitle: `Subcategory ${category.subCategories.length + 1}`,  // Use length for index
          description: '',
          checkBox: false,
          questions: [{ question: '', answer: '' }]
        });
      }
    }
  
    setFormStructure(updatedForms); // Update the form structure
  };
   
  
  
  
  const removeSubCategory = (formIndex, sectionIndex, categoryIndex, subCategoryIndex) => {
    const updatedForms = [...formStructure]; // Clone the form structure
    const updatedCategories = updatedForms[formIndex].sections[sectionIndex].categories[categoryIndex];
  
    // Remove the subcategory at the specified index
    updatedCategories.subCategories = updatedCategories.subCategories.filter(
      (_, index) => index !== subCategoryIndex
    );  
    setFormStructure(updatedForms); // Update the form structure
  };
 



  
  const handleAnswerInputChange = (
    formId,         // ID of the form
    sectionIndex,   // Section index in the form
    categoryIndex,  // Category index in the section
    questionIndex,  // Question index in the category or subcategory
    value,          // New value (either boolean for checkbox or string for answer)
    subCategoryIndex = null // Subcategory index, optional
  ) => {
    // Deep clone the form structure
    const updatedForms = cloneDeep(formStructure);
  
    // Find the form by its id
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error("Form not found", formId);
      return;
    }
  
    // Find the section by its index
    const section = form.sections[sectionIndex];
    if (!section) {
      console.error(`Section at index ${sectionIndex} is not found.`);
      return;
    }
  
    // Find the category by its index
    const category = section.categories[categoryIndex];
    if (!category) {
      console.error(`Category at index ${categoryIndex} is not found.`);
      return;
    }
  
    let targetQuestion;
  
    // If subCategoryIndex is null, we are working with a parent category
    if (subCategoryIndex === null) {
      // Access the parent category's question
      if (!category.questions || !category.questions[questionIndex]) {
        console.error(`Question at index ${questionIndex} in category is not found.`);
        return;
      }
      targetQuestion = category.questions[questionIndex];
    } else {
      // We are working with a subcategory
      const subCategory = category.subCategories[subCategoryIndex];
      if (!subCategory || !subCategory.questions || !subCategory.questions[questionIndex]) {
        console.error(`Subcategory or Question at given index is not found.`);
        return;
      }
      targetQuestion = subCategory.questions[questionIndex];
    }
  
    // Check whether we are using a checkbox or regular input for answers
    const isCheckBox = subCategoryIndex === null
      ? category.checkBox
      : category.subCategories[subCategoryIndex]?.checkBox;
  
    // Update the booleanAnswer for checkbox or string answer for input
    if (isCheckBox) {
      targetQuestion.booleanAnswer = value;
    } else {
      targetQuestion.answer = value;
    }
  
    // Finally update the form structure in the state
    setFormStructure(updatedForms);
  };
  
  
  const handleQuestionInputChange = (
    formId,
    sectionIndex,
    categoryIndex,
    questionIndex,
    field, // Field to update (e.g., 'question', 'answer', 'bgColor', etc.)
    value, // New value to set for the field
    subCategoryIndex = null // Optional subcategory index
  ) => {
    // Clone the form structure array
    const updatedForms = [...formStructure];
  
    // Find the form by formId
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error(`Form not found with id ${formId}`);
      return;
    }
  
    // Safely access the section by sectionIndex
    const section = form.sections[sectionIndex];
    if (!section || !section.categories) {
      console.error(`Section or categories not found at index ${sectionIndex}`);
      return;
    }
  
    // Safely access the category by categoryIndex
    const category = section.categories[categoryIndex];
    if (!category) {
      console.error(`Category not found at index ${categoryIndex}`);
      return;
    }
  
    let targetQuestion;
  
    // Check if we are working with a main category or subcategory
    if (subCategoryIndex === null) {
      // Access the parent category's question
      if (!category.questions || !category.questions[questionIndex]) {
        console.error(`Question at index ${questionIndex} in category is not found.`);
        return;
      }
      targetQuestion = category.questions[questionIndex];
    } else {
      // Ensure subCategories exist
      if (!category.subCategories || !category.subCategories[subCategoryIndex]) {
        console.error(`Subcategory at index ${subCategoryIndex} is not found.`);
        return;
      }
  
      // Access the subcategory's question
      const subCategory = category.subCategories[subCategoryIndex];
      if (!subCategory || !subCategory.questions || !subCategory.questions[questionIndex]) {
        console.error(`Question at index ${questionIndex} in subcategory is not found.`);
        return;
      }
      targetQuestion = subCategory.questions[questionIndex];
    }
  
    // Update the specific field (e.g., question, answer, booleanAnswer, bgColor, textColor, etc.)
    targetQuestion[field] = value;
  
    // Set the updated form structure
    setFormStructure(updatedForms);
  };
  
  const renderQuestion = ({
    form,
    sectionIndex,
    categoryIndex,
    subCategoryIndex = null,
    questionIndex,
    q,
    viewMode,
    checkBox,
    handleAnswerInputChange,
    handleQuestionInputChange,
    removeQuestion,
    tokenLoaded,
  }) => {
    return (
      <div className='mb-2 mt-2 mx-1' border='success'>
        <div key={questionIndex} className='justify-content-center align-items-center'>
          {viewMode ? (
            <figure className='text-start'>
              <MDBTypography blockquote>
                <p>{q?.question || ''}: <strong>{q?.booleanAnswer ? 'Yes' : 'No'}</strong></p>
              </MDBTypography>
              {q.blockquote && (
                <figcaption className='blockquote-footer'>
                  <cite title='Source Title'>{q.blockquote || 'No blockquote available'}</cite>
                </figcaption>
              )}
            </figure>
          ) : (
            <div className={viewMode ? 'mb-0' : 'position-relative'}>
              <div>
                {tokenLoaded && !viewMode && (
                  <>
                    <MDBInput
                      label="Question Blockquote"
                      value={q.blockquote || ''}
                      onChange={(e) =>
                        handleQuestionInputChange(
                          form.id,
                          sectionIndex,
                          categoryIndex,
                          questionIndex,
                          'blockquote',
                          e.target.value,
                          subCategoryIndex
                        )
                      }
                      wrapperClass='mb-3'
                      labelStyle={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                        width: '100%',
                      }} // Style adjustments for label
                      style={{
                        paddingTop: '2rem', // Ensure label text doesn't overlap with the input
                        lineHeight: '1.3rem', // Improve label spacing
                      }}
                    />
                    <MDBRow>
                      <MDBCol>
                        <MDBInput
                          label="Question Background Color"
                          value={q.bgColor || ''}
                          onChange={(e) =>
                            handleQuestionInputChange(
                              form.id,
                              sectionIndex,
                              categoryIndex,
                              questionIndex,
                              'bgColor',
                              e.target.value,
                              subCategoryIndex
                            )
                          }
                          wrapperClass='mb-3'
                          labelStyle={{
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            wordBreak: 'break-word',
                            width: '100%',
                          }} // Style adjustments for label
                        />
                      </MDBCol>
                      <MDBCol>
                        <MDBInput
                          label="Question Text Color"
                          value={q.textColor || ''}
                          onChange={(e) =>
                            handleQuestionInputChange(
                              form.id,
                              sectionIndex,
                              categoryIndex,
                              questionIndex,
                              'textColor',
                              e.target.value,
                              subCategoryIndex
                            )
                          }
                          wrapperClass='mb-3'
                          labelStyle={{
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            wordBreak: 'break-word',
                            width: '100%',
                          }} // Style adjustments for label
                        />
                      </MDBCol>
                    </MDBRow>
                  </>
                )}
              </div>
  
              <MDBRow>
                <MDBCol className='text-start text-black justify-content-center align-items-center'>
                  {checkBox ? (
                    <MDBCheckbox
                      className='text-start mb-1'
                      label={q?.question || 'No question available'}
                      checked={q?.booleanAnswer || false}
                      onChange={(e) =>
                        handleAnswerInputChange(
                          form.id,
                          sectionIndex,
                          categoryIndex,
                          questionIndex,
                          e.target.checked,
                          subCategoryIndex
                        )
                      }
                      wrapperClass='full-width'
                      labelStyle={{ wordBreak: 'break-word' }}
                    />
                  ) : (
                    <MDBTextArea
                      wrapperClass='mb-1'
                      label={q?.question}
                           rows={4}
                      labelStyle={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                        width: '100%',
                      }} // Adjust margin
                      value={q?.answer || ''}
                      onChange={(e) =>
                        handleAnswerInputChange(
                          form.id,
                          sectionIndex,
                          categoryIndex,
                          questionIndex,
                          e.target.value,
                          subCategoryIndex
                        )
                      }
                      style={{
                        marginTop: '1rem',
                      }} // Add margin to prevent overlapping
                    />
                  )}
                </MDBCol>
              </MDBRow>
  
              {/* Button to remove a question */}
              {tokenLoaded && !viewMode && (
                <MDBBtn
                  type='button'
                  className='position-absolute translate-middle top-0 end-0'
                  tag='a'
                  color='none'
                  onClick={() =>
                    removeQuestion(form.id, sectionIndex, categoryIndex, questionIndex, subCategoryIndex)
                  }
                >
                  <MDBIcon fas icon="times" />
                </MDBBtn>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };
  
  
  
  

  const removeQuestion = (formId, sectionIndex, categoryIndex, questionIndex, subCategoryIndex = null) => {
    // Deep clone the form structure
    const updatedForms = cloneDeep(formStructure);
  
    // Find the form by its id
    const form = updatedForms.find(f => f.id === formId);
    if (!form) {
      console.error("Form not found");
      return;
    }
  
    // Find the section by its index
    const section = form.sections[sectionIndex];
    if (!section) {
      console.error(`Section at index ${sectionIndex} is not found.`);
      return;
    }
  
    // Find the category by its index
    const category = section.categories[categoryIndex];
    if (!category) {
      console.error(`Category at index ${categoryIndex} is not found.`);
      return;
    }
  
    // Handle removing the question based on whether it's in the main category or subcategory
    let target;
    if (subCategoryIndex === null) {
      // If no subcategory, access questions directly in the category
      target = category.questions;
    } else {
      // If subcategory, access questions inside the subcategory
      const subCategory = category.subCategories[subCategoryIndex];
      if (!subCategory || !subCategory.questions) {
        console.error(`Subcategory at index ${subCategoryIndex} is not found.`);
        return;
      }
      target = subCategory.questions;
    }
  
    // Remove the question at the specified index
    target.splice(questionIndex, 1);
  
    // Set the updated form structure
    setFormStructure(updatedForms);
  };

  
  
 
  
  

  return (
    <MDBContainer className="  mb-4 justify-content-between" breakpoint="md">
      
        {Array.isArray(formStructure) && formStructure
    .filter(form => tokenLoaded || form.clientView)
    .map((form, formIndex) => (
           <MDBAccordion key={formIndex} className='mb-2 mt-2' >
          <MDBAccordionItem  collapseId={formIndex+1} headerTitle={<h1>{form?.title}</h1>} >
      
        
             <form id={`${form?.user?.firstName}-${form?.user?.lastName}`} className={"text-center justify-content-center align-items-center h-100 "} key={formIndex}>

  {tokenLoaded && renderFormTitle(viewMode, formIndex, form?.title, handleFormTitleChange,handleFormClientViewChange,form.clientView)}




        {(!tokenLoaded && form?.clientView && !viewMode)? (
          <div className='mb-2 text-center mx-1 align-items-center justify-content-center'>
            <MDBCardHeader className="fs-1">Contact Info</MDBCardHeader>
            <div>
              <MDBRow className='mb-2'>
              <MDBCol xs="12" md="6" className="mb-2">
                  {(viewMode && form.user?.firstName) ? (
                    <p><strong>First name:</strong> {form.user?.firstName || ''}</p>
                  ) : (
                    <MDBInput
                      id='form6Example1'
                      label='First name'
                      name='firstName'
                      value={form.user?.firstName || ''}
                      onChange={(e) => handleInputChange(form.id,'firstName', e.target.value)}
                    />
                  )}
                </MDBCol>
                <MDBCol xs="12" md="6" className="mb-2">
                  {(viewMode && form.user?.firstName) ? (
                    <p><strong>Last name:</strong> {form.user?.lastName || ''}</p>
                  ) : (
                    <MDBInput
                      id='form6Example2'
                      label='Last name'
                      name='lastName'
                      value={form.user?.lastName || ''}
                      onChange={(e) => handleInputChange(form.id,'lastName', e.target.value)}
                    />
                  )}
                </MDBCol>
              </MDBRow>
              <MDBRow className='mb-2'>
              <MDBCol xs="12" md="6" className="mb-2">
                  {(viewMode && form.user?.firstName) ? (
                    <p><strong>Company name:</strong> {form.user?.companyName || ''}</p>
                  ) : (
                    <MDBInput
                      id='companyNameForm3'
                      label='Company name'
                      name='companyName'
                      value={form.user?.companyName || ''}
                      onChange={(e) => handleInputChange(form.id,'companyName', e.target.value)}
                    />
                  )}
                </MDBCol>
                <MDBCol xs="12" md="6" className="mb-2">
                  {(viewMode && form.user?.firstName) ? (
                    <p><strong>Role:</strong> {form.user?.role || ''}</p>
                  ) : (
                    <MDBInput
                      id='form6Title'
                      label='Role'
                      name='role'
                      value={form.user?.role || ''}
                      onChange={(e) => handleInputChange(form.id,'role', e.target.value)}
                    />
                  )}
                </MDBCol>
              </MDBRow>
              {(viewMode && form.user?.firstName) ? (
                <>
                  <p><strong>Website:</strong> {form.user?.webSiteUrl || ''}</p>
                  <p><strong>Email:</strong> {form.user?.email || ''}</p>
                  <p><strong>Phone:</strong> {form.user?.phone || ''}</p>
                </>
              ) : (
                <>
                  <MDBInput className='mb-2'
                    type="url"
                    id='websiteUrl'
                    label='Website'
                    name='webSiteUrl'
                    value={form.user?.webSiteUrl || ''}
                    onChange={(e) => handleInputChange(form.id,'webSiteUrl', e.target.value)}
                  />
                  <MDBInput className='mb-2'
                    type='email'
                    id='form6Example5'
                    label='Email'
                    name='email'
                    value={form.user?.email || ''}
                    onChange={(e) => handleInputChange(form.id,'email', e.target.value)}
                  />
                  <MDBInput
                    type='tel'
                    id='form6Example6'
                    label='Phone'
                    name='phone'
                    value={form.user?.phone || ''}
                    onChange={(e) => handleInputChange(form.id,'phone', e.target.value)}
                  />
                </>
              )}
            </div>
          </div>
        ) : form.user ? (
          <div className='mb-2 text-center align-items-center justify-content-center' >
            <MDBCardHeader className='fs-1'>Contact Info</MDBCardHeader>
            <div className='mb-2 text-center ms-2 me-2 align-items-center justify-content-center'>
              <MDBTable className=' text-start '>
                <MDBRow tag='dl'>
                  <MDBCol tag='dt' sm='3'>
                    Name
                  </MDBCol>
                  <MDBCol tag='dd' sm='9'>
                    {form.user?.firstName || ''} {form.user?.lastName || ''}
                  </MDBCol>
                  <MDBCol tag='dt' sm='3'>
                    Company
                  </MDBCol>
                  <MDBCol tag='dd' sm='9'>
                    {form.user?.companyName || ''}
                  </MDBCol>
                  <MDBCol tag='dt' sm='3'>
                    Role
                  </MDBCol>
                  <MDBCol tag='dd' sm='9'>
                    {form.user?.role || ''}
                  </MDBCol>
                  <MDBCol tag='dt' sm='3'>
                    Website
                  </MDBCol>
                  <MDBCol tag='dd' sm='9'>
                    {form.user?.webSiteUrl || ''}
                  </MDBCol>
                  <MDBCol tag='dt' sm='3'>
                    Email
                  </MDBCol>
                  <MDBCol tag='dd' sm='9'>
                    {form.user?.email || ''}
                  </MDBCol>
                  <MDBCol tag='dt' sm='3'>
                    Phone
                  </MDBCol>
                  <MDBCol tag='dd' sm='9'>
                    {form.user?.phone || ''}
                  </MDBCol>
                </MDBRow>
              </MDBTable>
            </div>
          </div>
        ) : null}

        {/* Sections and Categories */}
        {form?.sections?.map((section, sectionIndex) => (
             <MDBRow key={sectionIndex}>
              <MDBCol>
          <div className='mb-0' key={sectionIndex}    border='warning'>
          <MDBCardHeader>
          <div>
  <MDBRow className="g-0">
    <MDBCol md="4">
      {section.imageType === 'carousel' ? (
        <MDBCarousel showControls showIndicators fade keyboard>
          {section.imageUrls?.map((url, index) => (
            <MDBCarouselItem itemId={index + 1} key={index}>
              <img
                src={url}  // Use the URL from section.imageUrls
                className="d-block w-100 rounded-5"
                alt={`Slide ${index + 1}`}
                style={{ height: '400px' }}
              />
            </MDBCarouselItem>
          ))}
        </MDBCarousel>
      ) : section.imageType === 'video' ? (
        <div className="d-flex justify-content-center align-items-center mt-2">
          <video
            src={section.imageUrl || 'https://opengrit.com/images/xtrkldemo'}
            className="img-thumbnail"
            alt="..."
            controls
            loop
            autoPlay
            muted
            style={{ height: '400px', width: 'auto' }}
          />
        </div>
      ) : (
        <MDBLightbox>
          <MDBLightboxItem
            style={{ width: '100%' }}
            zoomlevel={0.25}
            src={section.imageUrl || 'https://mdbootstrap.com/img/new/standard/city/041.webp'}
            fullscreenSrc={section.imageUrl || 'https://mdbootstrap.com/img/new/standard/city/041.webp'}
            className="rounded"
            alt="Feature Image"
          />
        </MDBLightbox>
      )}
    </MDBCol>
   
    <MDBCol md="8">
  <div>
    <div>
      {renderSectionTitle(
        tokenLoaded,
        viewMode,
        formIndex,
        sectionIndex,
        section.sectionTitle,
        section.blockquote,
        section.textColor,
        handleSectionTitleChange
      )}
      {tokenLoaded && !viewMode ? (
        <MDBRow className="mt-2 mb-2">
          <MDBCol>
            <MDBInput
              label="Section Background Color"
              value={section.bgColor || ''}
              onChange={(e) =>
                handleSectionColorChange(
                  formIndex,
                  sectionIndex,
                  'bgColor',
                  e.target.value
                )
              }
            />
          </MDBCol>
          <MDBCol>
            <MDBInput
              label="Section Text Color"
              value={section.textColor || ''}
              onChange={(e) =>
                handleSectionColorChange(
                  formIndex,
                  sectionIndex,
                  'textColor',
                  e.target.value
                )
              }
            />
          </MDBCol>
          <MDBCol>
            <div key={`section-${sectionIndex}`}>
              <MDBDropdown className="mb-2">
                <MDBDropdownToggle type="button">
                  {section.imageType
                    ? section.imageType.charAt(0).toUpperCase() +
                      section.imageType.slice(1)
                    : 'Select Type'}
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  <MDBDropdownItem
                    link
                    onClick={() =>
                      handleImageTypeChange(
                        form.id,
                        sectionIndex,
                        'image'
                      )
                    }
                  >
                    Image
                  </MDBDropdownItem>
                  <MDBDropdownItem
                    link
                    onClick={() =>
                      handleImageTypeChange(
                        form.id,
                        sectionIndex,
                        'carousel'
                      )
                    }
                  >
                    Carousel
                  </MDBDropdownItem>
                  <MDBDropdownItem
                    link
                    onClick={() =>
                      handleImageTypeChange(
                        form.id,
                        sectionIndex,
                        'video'
                      )
                    }
                  >
                    Video
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>

              {section.imageType === 'carousel' ? (
                <div>
                  {section.imageUrls.map((url, urlIndex) => (
                    <div
                      key={`url-${urlIndex}`}
                      className="d-flex align-items-center mb-2"
                    >
                      <MDBBtn
                        size="sm"
                        color="link"
                        onClick={() =>
                          handleRemoveImageUrl(
                            form.id,
                            sectionIndex,
                            urlIndex
                          )
                        }
                        type="button"
                      >
                        <MDBIcon
                          fas
                          icon="minus"
                          className="me-2 cursor-pointer"
                        />
                      </MDBBtn>

                      <MDBInput
                        label={`Image URL ${urlIndex + 1}`}
                        value={url}
                        onChange={(e) =>
                          handleImageUrlChange(
                            form.id,
                            sectionIndex,
                            urlIndex,
                            e.target.value
                          )
                        }
                        className="flex-grow-1"
                      />

                      <MDBBtn
                        size="sm"
                        color="link"
                        onClick={() => handleAddImageUrl( form.id, sectionIndex)}
                        type="button"
                      >
                        <MDBIcon
                          fas
                          icon="plus"
                          className="ms-2 cursor-pointer"
                        />
                      </MDBBtn>
                    </div>
                  ))}
                </div>
              ) : section.imageType === 'video' ? (
                <div className="d-flex justify-content-center align-items-center mt-2">
                  <video
                    src={section.imageUrl || 'https://opengrit.com/images/xtrkldemo'}
                    className="img-thumbnail"
                    alt="..."
                    controls
                    loop
                    autoPlay
                    muted
                    style={{ height: '400px', width: 'auto' }}
                  />
                </div>
              ) : (
                <MDBInput
                  label="Section Image URL"
                  value={section.imageUrl || ''}
                  onChange={(e) =>
                    handleSectionColorChange(
                      form.id,
                      sectionIndex,
                      'imageUrl',
                      e.target.value
                    )
                  }
                />
              )}
            </div>
          </MDBCol>
        </MDBRow>
      ) : null}

      {tokenLoaded && !viewMode && (
     <div>  <MDBInput
          label="Section Blockquote"
          value={section.blockquote || ''}
          onChange={(e) =>
            handleSectionColorChange(
              form.id,
              sectionIndex,
              'blockquote',
              e.target.value
            )
          }
        />
<MDBTextArea className='mt-2'
                label='Description'
                rows={2}
                value={section.description || ''}
                onChange={(e) =>
                  handleSectionColorChange(
                    form.id,
                    sectionIndex,
                    'description',
                    e.target.value
                  )
                }
              />
              </div>
      )}
    </div>
  </div>
</MDBCol>

  </MDBRow>
</div>


           
</MDBCardHeader>

            <div>
  {Array.isArray(form.sections) && section.categories.map((category, categoryIndex) => (
    <div key={categoryIndex}>
    <div className='position-relative  mb-2 justify-content-between' border='primary' >
      <MDBCardHeader className='text-start  mx-1'>
        {(viewMode || !tokenLoaded) ? (

<figure className='text-end mb-0 text-center p-0'  >
<MDBTypography blockquote>
<h4 className='text-success'>{category.categoryTitle}</h4>
</MDBTypography>
{category.blockquote &&   <figcaption className='blockquote-footer mb-0'>
  <cite title='Source Title'> {category.blockquote || 'No blockquote available'}</cite>
 
</figcaption>}
</figure>

         
        ) : (
          <MDBInput className='mb-2'
  label="Category Title"
  value={category.categoryTitle || ""}
  onChange={(e) => handleCategoryTitleChange(formIndex, sectionIndex, categoryIndex, e.target.value)} 
/>

        )}
        <MDBRow className='p-0 text-start'>
        {!viewMode && tokenLoaded && category.numberOfSubCategories===1 &&(     
          
          <MDBCol>
<MDBCheckbox
  label='Use checkbox for answers?'
  checked={category.checkBox || false}  // Default to false if undefined
  onChange={(e) => handleIsCheckBoxChange(formIndex, sectionIndex, categoryIndex, e.target.checked)}
/>


</MDBCol> 
 )}
{tokenLoaded && !viewMode &&<MDBCol>
<MDBInput className='mb-2'
  type="number"
  min="1"
  max="5"
  label="Number of Subcategories"
  value={category.numberOfSubCategories || 1}
  onChange={(e) => handleNumberOfSubCategoriesChange(formIndex, sectionIndex, categoryIndex, e.target.value)}
/>

</MDBCol>}
</MDBRow>


  
  {tokenLoaded && !viewMode && <>
    <MDBInput className='mb-2'
      label="Category Background Color"
      value={category.bgColor || ''}
      onChange={(e) => handleCategoryChange(formIndex, sectionIndex, categoryIndex, 'bgColor', e.target.value)}
    />
    <MDBInput className='mb-2'
      label="Category Blockquote"
      value={category.blockquote || ''}
      onChange={(e) => handleCategoryChange(formIndex, sectionIndex, categoryIndex, 'blockquote', e.target.value)}
    /> 

    <MDBInput
      label="Category Image URL"
      value={category.imageUrl || ''}
      onChange={(e) => handleCategoryChange(formIndex, sectionIndex, categoryIndex, 'imageUrl', e.target.value)}
    /></>
  }



      </MDBCardHeader>
  
      {/* Remove category button on the top-right corner */}
      {tokenLoaded && !viewMode &&(
        <MDBBtn
          type='button'
          className='position-absolute top-0 end-0 m-1'
          tag='a'
          color='none'
          onClick={() => removeCategory(formIndex, sectionIndex, categoryIndex)}  // Ensure correct indices
        >
          remove category
        </MDBBtn>
      )}
{category.numberOfSubCategories > 1 && Array.isArray(category.subCategories) ? (
  <MDBScrollbar style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
    <MDBRow className='flex-nowrap text-start row-cols-1 row-cols-md-2'>
      {category.subCategories.map((subCategory, subCategoryIndex) => (
        <MDBCol key={`subcategory-${subCategoryIndex}`}>
          <div className='mx-1 mb-2 position-relative' border='dark' > {/* Reduced margin here */}

            {/* Remove button on the top-right corner */}
            {tokenLoaded && !viewMode &&(
              <MDBBtn
                type='button'
                className='position-absolute top-0 end-0 m-1'
                tag='a'
                color='none'
                onClick={() => removeSubCategory(formIndex, sectionIndex, categoryIndex, subCategoryIndex)}  // Ensure correct indices
              >
                <MDBIcon fas icon="times" />
              </MDBBtn>
            )}

            <MDBCardHeader className='mx-2 '>
              {(viewMode || !tokenLoaded) ? (
                <figure className='mb-0 text-center p-0'>
                  <MDBTypography blockquote>
                    <h5 className='text-warning'>{subCategory.categoryTitle}</h5>
                  </MDBTypography>
                  {subCategory.blockquote && (
                    <figcaption className='blockquote-footer mb-0 p-0'>
                      <cite title='Source Title'>{subCategory.blockquote}</cite>
                    </figcaption>
                  )}
                </figure>
              ) : (
                 (!viewMode && tokenLoaded) &&
                 <MDBRow className='p-0 text-start'>
                 <MDBCol>
                   <MDBInput 
                     label="Subcategory Title"
                     value={subCategory.categoryTitle || ''}
                     onChange={(e) => handleSubCategoryChange(formIndex, sectionIndex, categoryIndex, subCategoryIndex, 'categoryTitle', e.target.value)}
                   />
                 </MDBCol>
                 <MDBCol>
                   <MDBInput
                     label="Sub Category Blockquote"
                     value={subCategory.blockquote || ''}
                     onChange={(e) => handleSubCategoryChange(formIndex, sectionIndex, categoryIndex, subCategoryIndex, 'blockquote', e.target.value)}
                   />
                 </MDBCol>
               </MDBRow>
               
              )}
              {tokenLoaded &&  !viewMode &&(
                <MDBCheckbox
                  label='Use checkbox for answers?'
                  checked={subCategory.checkBox || false}  // Default to false if undefined
                  onChange={(e) => handleSubCategoryIsCheckBoxChange(formIndex, sectionIndex, categoryIndex, subCategoryIndex, e.target.checked)}
                />
              )}
            </MDBCardHeader>

            

            {/* Questions in the subcategory */}
            {Array.isArray(subCategory.questions) && subCategory.questions.map((q, questionIndex) =>
              renderQuestion({
                form,
                sectionIndex,
                categoryIndex,
                subCategoryIndex,
                questionIndex,
                q,
                viewMode,               
                checkBox: subCategory.checkBox,
                handleAnswerInputChange,
                handleQuestionInputChange,
                removeQuestion
              })
            )}

          {!viewMode &&  <MDBCardFooter className='text-center'>
              <MDBTextArea
                label='Subcategory Description'
                rows={2}
                value={subCategory?.description || ''}
                onChange={(e) => handleSubCategoryDescriptionChange(form.id, sectionIndex, categoryIndex, subCategoryIndex, e.target.value)}
              />
             {!viewMode && tokenLoaded && <MDBBtn color='warning' className='mt-2' onClick={() => addSubCategoryQuestion(formIndex, sectionIndex, categoryIndex, subCategoryIndex)} type='button'>
                Add New Subcategory Question
              </MDBBtn>}
            </MDBCardFooter> }
          </div>
        </MDBCol>
      ))}
    </MDBRow>
  </MDBScrollbar>
) : (
  // Conditionally render parent category's questions only if numberOfSubCategories is 1
  category.numberOfSubCategories === 1 && Array.isArray(category.questions) && category.questions?.map((q, questionIndex) =>
    renderQuestion({
      form,
      sectionIndex,
      categoryIndex,
      questionIndex,
      q,
      viewMode,
      checkBox: category.checkBox,
      handleAnswerInputChange,
      handleQuestionInputChange,
      removeQuestion
    })
  )
)}


{!viewMode ?
<MDBCardFooter>
  <MDBTextArea className="bg-light bg-gradient text-dark rounded-5"
    label='Anything more?'
    rows={2}
    value={category?.description || ''}
    onChange={(e) => handleCategoryDescriptionChange(form.id, sectionIndex, categoryIndex, e.target.value)}
  /> 

  {tokenLoaded && category.numberOfSubCategories === 1 && !viewMode &&(
    <MDBBtn color='primary' className='mt-2' onClick={() => addQuestion(form.id, sectionIndex, categoryIndex)} type='button'>
      Add New Question
    </MDBBtn>
  )}
</MDBCardFooter> :<MDBCardFooter>
<figure className='text-end mb-0 text-center p-0'  >

{category.description &&   <figcaption className='blockquote-footer mb-0 text-success'>
  <cite title='Source Title'> {category.description || 'No Description available'}</cite>
 
</figcaption>}
</figure>
  </MDBCardFooter>}

    </div>
  </div>
  
  ))}
</div>  
{tokenLoaded && !viewMode && <MDBCardFooter>
        <MDBBtn color='primary' onClick={() => addCategory(formIndex, sectionIndex)} type='button'>
          Add New Category
        </MDBBtn>
      </MDBCardFooter>}
          </div>
          </MDBCol>
          </MDBRow>
        ))}

<MDBModal open={isOpen} tabIndex='-1' onClose={() => setIsOpen(false)} nonInvasive={true} centered>
        <MDBModalDialog size='sm'>
          <MDBModalContent>
          <MDBModalHeader>
            
              <MDBBtn className='btn-close' color='none'onClick={() => setIsOpen(false)} type='button'></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody> <MDBIcon far icon="check-circle" size='5x'/></MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      <div className="button-container">
  <MDBBtnGroup className="gap-1 d-flex justify-content-center align-items-center mt-2 flex-wrap mx-3">
    {!viewMode && (
      <>
        <MDBBtn
          type="button"
          color="primary"
          onClick={() => createSalesQuestions(form.id)} // Pass form.id here
          className="btn-sm"
        >
          {tokenLoaded ? 'ADD' : 'Submit'}
        </MDBBtn>

        {tokenLoaded && (
          <>
            <MDBBtn
              type="button"
              color="warning"
              onClick={() => updateSalesQuestions(form.id)}
              className="btn-sm"
            >
              UPDATE
            </MDBBtn>

            <MDBBtn
              type="button"
              color="danger"
              onClick={() => deleteSalesQuestions(form.id)}
              className="btn-sm"
            >
              DELETE
            </MDBBtn>
          </>
        )}

        <MDBBtn
          type="button"
          color="secondary"
          onClick={() => clearQuestions(form.id)}
          className="btn-sm"
        >
          CLEAR Form
        </MDBBtn>
      </>
    )}

    <MDBBtn
      color="black"
      onClick={toggleViewMode}
      type="button"
      className="btn-sm"
    >
      {viewMode ? 'Switch to Edit Mode' : 'Switch to View Mode'}
    </MDBBtn>

    <MDBBtn
      type="button"
      className="bg-primary text-black bg-opacity-75 btn-sm"
      onClick={() => generateQtnAnsPDF(`${form?.user?.firstName}-${form?.user?.lastName}`)}
    >
      Save Your Answers as PDF
    </MDBBtn>
  </MDBBtnGroup>
</div>

       
      </form>
    </MDBAccordionItem>
      </MDBAccordion> 
      ))}


    </MDBContainer>
  );
};

export default RocketDemoBuilderForm;
